import type { IVerifyParams, IVerifyResult } from './verify';
import type { ISignParams, ISignResult } from './sign';
import type { ICheckLoginParams, ICheckLoginResult } from './checkLogin';
import { objectSchemaOf, Joi } from '../helpers';

export interface IOAuthSlackParams {
  organisationId: string;
  code: string;
  redirectUrl: string;
}

export const oAuthSlackParamsSchema = objectSchemaOf<IOAuthSlackParams>({
  organisationId: Joi.string().required(),
  code: Joi.string().required(),
  redirectUrl: Joi.string().required(),
});

export interface ILogoutConsoleParams {
  consoleId: string;
}

export const logoutConsoleParamsSchema = objectSchemaOf<ILogoutConsoleParams>({
  consoleId: Joi.string().required(),
});

export interface IAuthApi {
  authOAuthSlack(param: IOAuthSlackParams): Promise<void>;
  logoutConsole(param: ILogoutConsoleParams): Promise<void>;
  authVerify(param: IVerifyParams): Promise<IVerifyResult>;
  authSign(param: ISignParams): Promise<ISignResult>;
  authCheckLogin(param: ICheckLoginParams): Promise<ICheckLoginResult>;
}
